export const getReaderHref = (sku: string): string => {
	const BASE_URL = process.env.REACT_APP_EDELWEISS_READER_URL;
	return `${BASE_URL}/${sku}`;
};
